export const html = "<p>Fly the zipline at Yell Extreme Park in Enokavan.</p>\n";
export const leadHtml = "<p>Fly the zipline at Yell Extreme Park in Enokavan.</p>\n";
export const bodyHtml = "";
export const metaText = "Fly the zipline at Yell Extreme Park in Enokavan.";